import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import { formatIncomeAnswer, resolveHonorificKey, formatDepartment } from "../../utils/str"
import { HONORIFICS } from "../../constants/constants"

class FaqSeo extends React.Component {
  render() {
    const { item, relevantKeymans, departmentRelevantKeyman, honorificRelevantKeyman } = this.props
    const honorificKey = resolveHonorificKey(item.honorific)
    const honorific = HONORIFICS.find(item => item.value === honorificKey)
    // JSON+LDの設定
    const jsonLd = {
      "@context": "https://schema.org/",
      "@type": "FAQPage",
      "mainEntity": []
    }

    //平均年収のFAQ
    let incomeAnswer = ''
    if (item && item.annual_income) {
      incomeAnswer = formatIncomeAnswer(item)
      jsonLd.mainEntity.push({
        "@type": "Question",
        "name": `${item.name}さんの勤める${item.company_name}の平均年収は？`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": incomeAnswer
        }
      })
    }

    //近しい決裁者のFAQ
    if (departmentRelevantKeyman || honorificRelevantKeyman || Object.keys(relevantKeymans).length !== 0) {
      let closeAnswer = ''
      if (!!departmentRelevantKeyman) {
        closeAnswer = `${formatDepartment(item.honorific)}部門の${departmentRelevantKeyman.name}さん`
      }
      if (!!departmentRelevantKeyman && !!honorificRelevantKeyman) {
        closeAnswer += '、'
      }
      if (!!honorificRelevantKeyman) {
        closeAnswer += `${honorific.name}の${honorificRelevantKeyman.name}さん`
      }
      if (!!departmentRelevantKeyman || !!honorificRelevantKeyman) {
        closeAnswer += `などが部門や役職が近しい決裁者です。`
      }

      if (Object.keys(relevantKeymans).length !== 0) {
        relevantKeymans.forEach(item => {
          closeAnswer += `${item.honorific}の${item.name}さん、`
        })
        closeAnswer = closeAnswer.slice(0, -1)
        closeAnswer += `などが${item.company_name}に勤める関連度の高い決裁者です。`
      }
      jsonLd.mainEntity.push({
        "@type": "Question",
        "name": `${item.name}さんの勤める${item.company_name}の近しい決裁者は？`,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": closeAnswer
        }
      })
    }

    return (
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>
    )
  }
}

FaqSeo.propTypes = {
  item: PropTypes.object,
  departmentRelevantKeyman: PropTypes.object,
  honorificRelevantKeyman: PropTypes.object,
  relevantKeymans: PropTypes.array,
}

export default FaqSeo
